import { maxLength, minLength, required, helpers } from '@vuelidate/validators'

import { ValidatorsUtil } from '@shared/utils/Validators'
import { DateTimeUtil } from '@shared/utils/DateTime'

import validationsAPI from '@shared/api/validations'

const { withAsync } = helpers

export const dateOfBirth = {
  required,
  birthdate: ValidatorsUtil.isBirthDate,
}

export const email = {
  required,
  email: ValidatorsUtil.isMail,
}

export const firstName = {
  required,
  minLength: minLength(2),
  maxLength: maxLength(35),
  name: ValidatorsUtil.isName,
}

export const lastName = {
  required,
  minLength: minLength(2),
  maxLength: maxLength(60),
  name: ValidatorsUtil.isName,
}

export const mobile = {
  required,
  phone: ValidatorsUtil.isPhone
}

export const phone = {
  required,
  phone: withAsync(async value => {
    return await validationsAPI.validatePhoneNumber(value)
  }),
}

export const contractStartDate = {
  date: ValidatorsUtil.isDate,
  dateRange: ValidatorsUtil.isInDateRange(
    DateTimeUtil.getMinContractStartDate(),
    DateTimeUtil.getMaxContractStartDate()
  ),
}
